import {createVuetify} from 'vuetify/lib/framework.mjs';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import {de} from 'vuetify/locale';

export const vuetify = createVuetify({
  components,
  directives,
  locale: {
    locale: 'de',
    messages: {de},
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#415564', // {
          //   base: '#415564',
          //   lighten1: '#8da3b4',
          // },
          secondary: '#c8ac8c',
          success: '#009E73',
          warning: '#E69F00',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#415564', // {
          //   base: '#415564',
          //   lighten1: '#8da3b4',
          // },
          secondary: '#c8ac8c',
          success: '#009E73',
          warning: '#E69F00',
        },
      },
    },
    variations: {
      colors: ['primary', 'secondary', 'success', 'warning', 'error', 'orange', 'grey', 'blue'],
      lighten: 4,
      darken: 4,
    },
  },
});
